import { IconButton, Tooltip } from '@mui/material';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

/** The one expand-all / collapse-all toggle for a document's sections. Pair it with `useExpandAll`. */
export function ExpandAllSectionsButton({ allExpanded, onToggle }: { allExpanded: boolean; onToggle: () => void }) {
  const label = allExpanded ? 'Collapse all sections' : 'Expand all sections';
  return (
    <Tooltip title={label}>
      <IconButton size="small" onClick={onToggle} aria-label={label}>
        {allExpanded ? <UnfoldLessIcon fontSize="small" /> : <UnfoldMoreIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
